import CareerPathJobProgression from './CareerPathJobProgression'
export default CareerPathJobProgression
